import { ImageContentGridBottom } from "../../../../modules/content/components/ImageContentGridBottom/ImageContentGridBottom";
import { ImageContentGridTop } from "../../../../modules/content/components/ImageContentGridTop/ImageContentGridTop";
import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IImageContentGridBlockProps } from "./ImageContentGridBlock.props";

export const ImageContentGridBlock = (props: IImageContentGridBlockProps) => {
  const {
    alignment,
    anchorId,
    buttons,
    description,
    eyebrow,
    heading,
    items,
    parentClass,
    spacing,
    variant,
  } = props;
  if (!items?.length) return null;
  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "image-bottom" ? (
          <ImageContentGridBottom {...props} />
        ) : (
          <ImageContentGridTop {...props} />
        )}
      </div>
    </AbyssSection>
  );
};

ImageContentGridBlock.displayName = "Block::ImageContentGridBlock";
